import { useState } from 'react';
import { VERMI_FRONT_1KG, VERMI_FRONT_5KG, VERMI_BACK_1KG } from '../../data/parasHomeData';
import { CheckCircleIcon, FlaskIcon } from './HomeIcons';

export default function VermicompostSection() {
  const [vermiImg, setVermiImg] = useState(0);
  const vermiImages = [VERMI_FRONT_1KG, VERMI_BACK_1KG, VERMI_FRONT_5KG];

  return (
    <section className="section product-section alt" id="vermicompost" aria-label="Vermicompost product">
      <div className="section-inner">
        <div className="product-grid flip-on-mobile">
          <div className="product-image-col" style={{ order: 1 }}>
            <div className="product-image-frame">
              <img src={vermiImages[vermiImg]} alt="Paras Premium Organic Vermicompost" />
            </div>
            <div className="img-thumb-row">
              {vermiImages.map((src, i) => (
                <img
                  key={i}
                  src={src}
                  alt={`Vermicompost view ${i + 1}`}
                  className={`img-thumb${vermiImg === i ? ' active' : ''}`}
                  onClick={() => setVermiImg(i)}
                />
              ))}
            </div>
          </div>
          <div className="product-info-col" style={{ order: 0 }}>
            <div className="product-badge-row">
              <span className="badge gold">FCO Certified</span>
              <span className="badge">100% Organic</span>
              <span className="badge">Made from Cow Dung</span>
              <span className="badge">Odour Free</span>
            </div>
            <h2 className="product-name">Premium Organic<br />Vermicompost</h2>
            <p className="product-tagline">
              A premium-quality organic fertilizer carefully processed in a controlled environment to maximize nutritional value. Rich in Nitrogen, Phosphorus, and Potash - completely free from chemicals and additives.
            </p>
            <div className="composition-table" aria-label="Nutrient composition">
              <h4><FlaskIcon className="ui-icon section-inline-icon" />Composition (FCO Standard)</h4>
              <div className="comp-grid">
                <div className="comp-item"><span className="comp-label">Nitrogen (N)</span><span className="comp-val">1 - 1.5%</span></div>
                <div className="comp-item"><span className="comp-label">Phosphorus (P)</span><span className="comp-val">1 - 1.3%</span></div>
                <div className="comp-item"><span className="comp-label">Potassium (K)</span><span className="comp-val">0.8 - 1%</span></div>
                <div className="comp-item"><span className="comp-label">pH Level</span><span className="comp-val">6.5 - 7.0</span></div>
              </div>
            </div>
            <ul className="features-list">
              <li><span className="feat-icon"><CheckCircleIcon className="ui-icon feature-check-icon" /></span>Rich in microbial bio-stimulants that enhance disease resistance and healthy soil microflora</li>
              <li><span className="feat-icon"><CheckCircleIcon className="ui-icon feature-check-icon" /></span>Improves soil quality naturally - ideal for organic and sustainable farming</li>
              <li><span className="feat-icon"><CheckCircleIcon className="ui-icon feature-check-icon" /></span>Fine-grained texture enhances soil aeration and porosity for better root development</li>
              <li><span className="feat-icon"><CheckCircleIcon className="ui-icon feature-check-icon" /></span>Ideal for garden beds, soil farming, and all potted plants - indoor or outdoor</li>
            </ul>
            <div className="product-cta-row">
              <a href="/vermicompost" className="btn-primary">View Full Details</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
